import ValidationBanner from './ValidationBanner'
import { BACKEND_UNAVAILABLE_MESSAGE } from '../../utils/apiError'

const DEFAULT_UNAVAILABLE_MESSAGE =
  'We apologize for the inconvenience. Please try again later.'

type ServiceUnavailableProps = {
  /** HTTP status of the response that triggered this screen, when known. */
  status?: number
}

/** Renders the limited application content shown while TORT is unavailable. */
const ServiceUnavailable = ({ status }: ServiceUnavailableProps): JSX.Element => (
  <main
    className="fixed inset-0 z-50 flex items-center justify-center "
    style={{
      display: 'flex',
    }}
  >
    <div className="max-w-3xl w-full">
      <ValidationBanner
        // 504 (gateway timeout) is the "TORT couldn't process your request"
        // case — shown as an error banner with just the support-contact
        // message: no heading, no custom icon (falls back to the default
        // error icon). Every other 5xx in this class keeps the original
        // informational outage copy, but with a heading and the alert icon.
        variant={status === 504 ? 'error' : 'info'}
        heading={status === 504 ? undefined : 'TORT is temporarily unavailable.'}
        message={status === 504 ? BACKEND_UNAVAILABLE_MESSAGE : DEFAULT_UNAVAILABLE_MESSAGE}
        compact={false}
        iconSrc={status === 504 ? undefined : '/assets/images/alertSolid.svg'}
        />
    </div>
  </main>
)

export default ServiceUnavailable